import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ServicesService } from '../../services/services.service';

@Injectable()
export class MaintenanceRequestService {
  constructor(private readonly http: ServicesService) {
    
  }
  
  getMaintenanceRequests(): Observable<any> {
    return this.http.postRequest<any>({}, 'get-maintenance-requests');
  }

  /* Accept/Reject Maintenance requests. */
  changeMaintenanceRequest(param: any): Observable<any> {
    return this.http.postRequest<any>(param, 'change-maintenance-status');
  }

  updateMaintenanceRequest(param: any): Observable<any> {
    return this.http.postRequest<any>(param, 'update-request-maintenance');
  }

  getEmployeeList(param: any): Observable<any> {
    return this.http.postRequest<any>(param, 'get-employee-list');
  }

  updateEmployeeInstruction(requestId: number, instructions: string): Observable<any> {
    const data = {
      request_id: requestId,
      employee_instructions: instructions
    }

    return this.http.postRequest<any>(data, 'update-maintenance-request-employee-instructions');
  }
}
